import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import '../styles/EditProfile.css';

function EditProfile({ isOpen, onClose }) {
  const { user, updateUser } = useAuth();
  const [fullName, setFullName] = useState('');
  const [country, setCountry] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (user) {
      setFullName(user.full_name || '');
      setCountry(user.country || '');
    }
  }, [user, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const encodedPhone = encodeURIComponent(user.phone);
      const response = await axios.put(`${API_BASE_URL}/users/${encodedPhone}`, {
        full_name: fullName,
        country: country
      });

      if (response.data.success) {
        // Update user in context
        updateUser({
          ...user,
          full_name: fullName,
          country: country
        });
        setSuccess('تم تحديث الملف الشخصي بنجاح');
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        setError(response.data.message || 'حدث خطأ في تحديث الملف الشخصي');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ في تحديث الملف الشخصي');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  // The trigger lives in the app header, which uses backdrop-filter and so
  // becomes the containing block for position: fixed children. Portalling to
  // body keeps the overlay anchored to the viewport instead of the header.
  return createPortal(
    <div className="edit-profile-overlay" onClick={onClose}>
      <div className="edit-profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-profile-header">
          <h2>تعديل الملف الشخصي</h2>
          <button className="close-button" onClick={onClose}>
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="edit-profile-form">
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <div className="form-group">
            <label htmlFor="fullName">الاسم الكامل</label>
            <input
              type="text"
              id="fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              placeholder="أدخل الاسم الكامل"
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">البلد</label>
            <input
              type="text"
              id="country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              required
              placeholder="أدخل البلد"
            />
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="save-button"
              disabled={loading}
            >
              {loading ? 'جاري الحفظ...' : 'حفظ التغييرات'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default EditProfile;

